// Mood Board Color
export const BG_PRIMARY = '#9C93B6';
export const BG_SECONDARY = '#D2CDDC';
export const BG_ALTERNATIVE = '#8E80B8';
export const BG_OPACITY = '#BCB8C8';
export const BG_LAYER = 'rgb(255 248 241 / 61%)';
export const BG_LAYER_BORDER = '#A48761';

// GRADIENT COLORS
export const BUTTON_GRADIENT = `linear-gradient(to left, ${BG_ALTERNATIVE}, ${BG_OPACITY} 140%)`;

// Text Color
export const TEXT_PRIMARY = '#735C3D'; //brown dark
export const TEXT_SECONDARY = '#8E80B8'; // Title color section

// Music & Navigation Color
export const NAVIGATION_COLOR = BG_ALTERNATIVE; // Warna BG
export const ICON_NAVIGATION_COLOR = 'white'; // Warna Iconnya
// Drawer Color
export const DRAWER_COLOR = 'rgb(255 248 241 / 100%)';

// Default Button Color
export const BUTTON_PROPS = {
  _active: { opacity: '.8' },
  _hover: { opacity: '.8' },
  _focus: { opacity: '.8' },
};
